// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarStar_wrapper__3mf1l","avatar":"AvatarStar_avatar__3FkPh","star_wrapper":"AvatarStar_star_wrapper__O-hnZ","icon_star":"AvatarStar_icon_star__2g5zL"};